import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";
import { useBackButton } from "./useBackButton";

interface BackButtonProps {
  label?: string;
  to?: string;
}

const BackButtonBase = styled(Button)(({ theme }) => ({
  alignSelf: "flex-start",
  marginBottom: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

export function BackButton({ label, to }: BackButtonProps) {
  const { handleClick } = useBackButton(to);
  const { t } = useTranslation();

  return (
    <BackButtonBase startIcon={<ArrowBackIcon />} onClick={handleClick}>
      {label ?? t("common.back")}
    </BackButtonBase>
  );
}
